module.exports = __webpack_public_path__ + "img/shop_header-1.c8e31589.png";